/**
 * Parse an ISO 8601-ish string as UTC. Telemetry DTOs are inconsistent:
 * some events serialize with a trailing Z, others do not. Plain Date.parse
 * treats a no-Z string as browser-local time, which silently shifts every
 * cross-record timestamp comparison by the browser's UTC offset. Normalize
 * by appending Z when the string carries no timezone designator. Returns
 * null for missing or invalid input.
 */
export function parseUtc(raw: unknown): number | null {
  if (!raw) return null;
  let s = String(raw).replace(" ", "T");
  if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(s)) s += "Z";
  const t = Date.parse(s);
  return Number.isNaN(t) ? null : t;
}
